export default __webpack_public_path__ + "static/media/example-image.0d62d7ab.png";